import { Box, Container, Link, Typography, styled } from '@mui/material';

const year = new Date().getFullYear();
const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        py={4}
        px={4}

        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1">
            &copy; {year} - Prizeet Admin Dashboard
          </Typography>
        </Box>
        <Typography
          sx={{
            pt: { xs: 2, md: 0 }
          }}
          variant="subtitle1"
        >
          Crafted by{' '}
          <Link href="#" target="_blank" rel="noopener noreferrer">
            Prizeet Team'
          </Link>
        </Typography>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
